import React from "react";
import { Github, Linkedin, Mail } from "lucide-react";

const links = [
  {
    href: "mailto:anthonydo@ucla.edu",
    icon: Mail,
    label: "anthonydo@ucla.edu",
    external: false,
  },
  {
    href: "https://github.com/anthonysk0215",
    icon: Github,
    label: "github.com/anthonysk0215",
    external: true,
  },
  {
    href: "https://www.linkedin.com/in/anthonydo6/",
    icon: Linkedin,
    label: "linkedin.com/in/anthonydo6",
    external: true,
  },
];

export default function Footer() {
  return (
    <footer className="mt-auto w-full border-t border-gray-200 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-7">
        <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
          <nav className="flex flex-wrap items-center gap-x-7 gap-y-3">
            {links.map(({ href, icon: Icon, label, external }) => (
              <a
                key={href}
                href={href}
                {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                className="group inline-flex items-center gap-2 text-sm text-gray-500 hover:text-blue-500 transition-colors duration-200"
              >
                <Icon
                  strokeWidth={1.5}
                  className="h-4 w-4 text-gray-400 group-hover:text-blue-500 transition-colors duration-200"
                />
                <span>{label}</span>
              </a>
            ))}
          </nav>
          <p className="text-xs text-gray-400">© 2025 Anthony Do. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
